import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

export const discoveryBadgesApi = {
  getBadges: async () => {
    const response = await axios.get(`${API_URL}/api/admin/discovery-badges`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  createBadge: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/discovery-badges`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateBadge: async (id: string, data: any) => {
    const response = await axios.put(`${API_URL}/api/admin/discovery-badges/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  deleteBadge: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/discovery-badges/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
